// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import ListingCounts from 'components/ListingCounts';
import { fetchListingCounts as fetchListingCountsRaw } from '../redux/main/actions/listingCounts';

const { useEffect } = React;

type Props = {
  listingCounts: ?{ [string]: number },
  fetchListingCounts: Object => void
};

const ListingCountsContainer = ({
  listingCounts,
  fetchListingCounts
}: Props) => {
  useEffect(
    () => {
      fetchListingCounts({
        indices: ['MAIN_SEARCH', 'VOLOPS']
      });
    },
    [fetchListingCounts]
  );

  return <ListingCounts listingCounts={listingCounts} />;
};

const mapStateToProps = ({ listingCounts }) => ({
  listingCounts
});

export default connect<Props, {}, _, _, _, _>(
  mapStateToProps,
  { fetchListingCounts: fetchListingCountsRaw }
)(ListingCountsContainer);
